/* OPA product description layout: groups each H2 section and styles known sections. All text stays in the DOM. */
(function () {
  var host = null;
  document.querySelectorAll('.hdt-section-main-product-tabs .hdt-rte').forEach(function (el) {
    if (!host && el.querySelector('h2')) host = el;
  });
  if (!host || host.classList.contains('opa-pd')) return;

  var text = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); };
  var kids = Array.prototype.slice.call(host.children);
  if (!kids.some(function (k) { return k.tagName === 'H2'; })) return;

  host.classList.add('opa-pd');

  // Lead paragraph(s) before the first H2
  var i = 0;
  while (i < kids.length && kids[i].tagName !== 'H2') {
    if (kids[i].tagName === 'P' && i === 0) kids[i].classList.add('opa-pd__lead');
    i++;
  }

  // Wrap each H2 and its following siblings in a section
  var sections = [];
  for (; i < kids.length; i++) {
    var k = kids[i];
    if (k.tagName === 'H2') {
      var sec = document.createElement('section');
      sec.className = 'opa-pd__sec';
      host.insertBefore(sec, k);
      sections.push(sec);
    }
    if (sections.length) sections[sections.length - 1].appendChild(k);
  }

  sections.forEach(function (sec) {
    var h = sec.querySelector('h2');
    var title = text(h).toLowerCase();
    var ul = sec.querySelector('ul');

    if (/who this formula is for|who it.?s for/.test(title) && ul) ul.classList.add('opa-pd__checks');

    if (/ingredient/.test(title) && ul) ul.classList.add('opa-pd__ingredients');

    if (/supplement facts|at a glance/.test(title) && ul) {
      ul.classList.add('opa-pd__facts');
      ul.querySelectorAll('li').forEach(function (li) {
        var t = text(li), c = t.indexOf(':');
        var only = li.children.length === 1 && li.children[0].tagName === 'P' && !li.children[0].children.length;
        if (c < 1 || (li.children.length && !only)) return;
        var k = document.createElement('span'), v = document.createElement('span');
        k.className = 'opa-pd__k'; v.className = 'opa-pd__v';
        k.textContent = t.slice(0, c); v.textContent = t.slice(c + 1).trim();
        li.textContent = ''; li.appendChild(k); li.appendChild(v);
      });
    }

    if (/suggested use|how to use|directions/.test(title)) {
      var box = document.createElement('div');
      box.className = 'opa-pd__use';
      Array.prototype.slice.call(sec.children).forEach(function (c) { if (c !== h) box.appendChild(c); });
      sec.appendChild(box);
    }

    if (/frequently asked|faq/.test(title)) {
      var wrap = document.createElement('div');
      wrap.className = 'opa-pd__faq';
      var current = null;
      Array.prototype.slice.call(sec.children).forEach(function (c) {
        if (c === h) return;
        if (c.tagName === 'H3') {
          current = document.createElement('details');
          var s = document.createElement('summary');
          s.appendChild(c);
          current.appendChild(s);
          wrap.appendChild(current);
        } else if (current && c.tagName === 'P' && !/have not been evaluated/i.test(text(c))) {
          current.appendChild(c);
        } else {
          sec.appendChild(c);
        }
      });
      h.insertAdjacentElement('afterend', wrap);
    }

    if (/related guides/.test(title) && ul) {
      ul.classList.add('opa-pd__guides');
      var more = sec.querySelector('p');
      if (more) more.classList.add('opa-pd__more');
    }
  });

  // FDA disclaimer: small print, wherever it ended up
  host.querySelectorAll('p').forEach(function (p) {
    if (/have not been evaluated by the food and drug/i.test(text(p))) {
      p.classList.add('opa-pd__disclaimer');
      host.appendChild(p);
    }
  });
})();
